export type NavDirection = 'left' | 'right' | null;

let _direction: NavDirection = null;

export function setNavDirection(d: NavDirection): void { _direction = d; }
export function consumeNavDirection(): NavDirection {
  const d = _direction;
  _direction = null;
  return d;
}
